module.exports = __webpack_public_path__ + "img/icon-pdf.2c5de8e7.png";